import { useRef, useEffect } from 'react';

const useOutsideClick = (callback, disabled) => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target) && !disabled) {
        callback();
      }
    };
    document.addEventListener('click', handleClick, true);
    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref, disabled, callback]);

  return ref;
};

export default useOutsideClick;
